var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.80005 1C2.80005 0.447716 3.24776 0 3.80005 0H8.94859C10.2773 0 11.2367 1.27181 10.8716 2.54944L10.8 2.8L11.5727 2.63099C12.8199 2.35815 14 3.30801 14 4.58479V13C14 13.5523 13.5523 14 13 14H3.80005C3.24776 14 2.80005 13.5523 2.80005 13V1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4.92139L0.270429 12.7045C0.131648 13.329 0.606868 13.9214 1.24662 13.9214H2V4.92139Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.c9a67c60d7347053cb23ae34842840b6.svg";
export { ForwardRef as ReactComponent };